import { Avatar, Skeleton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import useSWRInfinite from "swr/infinite";
import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";

import {
  getSettingState,
  setCategoryExplor,
  setLoadNavigation,
} from "../../../../redux/features/settingSlice";

const Category = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { categoryExplor } = useSelector(getSettingState);

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const {
    data: category,
    isLoading,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;
      return `${process.env.REACT_APP_API}/content/categories/?page=${
        pageIndex + 1
      }`;
    },
    {
      revalidateFirstPage: false,
    }
  );

  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    inView && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const moreInfinite = () => {
    const getNewPage = size + 1 <= category[0]?.total_pages;
    if (getNewPage) {
      setSize(size + 1);
      dispatch(setLoadNavigation(true));
    } else {
      setSize(category[0].total_pages);
    }
  };

  const dataList = () => {
    let dataArr = [];
    if (category) {
      // eslint-disable-next-line array-callback-return
      category.map((e) => {
        dataArr.push(...e.results);
      });
    }
    return dataArr;
  };

  return (
    <Box>
      {isLoading || !category ? (
        <Skeleton
          width={180}
          height={40}
          sx={{
            mb: "4px",
          }}
        />
      ) : (
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontWeight: 500,
            fontSize: "24px",
            mb: "4px",
          }}
        >
          {!categoryExplor && " Or choose a category"}
        </Typography>
      )}

      <Box>
        <Grid2 container spacing={2}>
          {(isLoading || !category) &&
            Array(10)
              .fill("")
              .map((row, i) => {
                return (
                  <Grid2 key={i} xxs={6}>
                    <Skeleton
                      width={"100%"}
                      height={"164px"}
                      variant='rounded'
                      sx={{ borderRadius: "16px" }}
                    />
                  </Grid2>
                );
              })}

          {!isLoading &&
            category &&
            dataList().map((row) => {
              return (
                <Grid2 key={row.pk} xxs={6}>
                  <Box
                    onClick={() => dispatch(setCategoryExplor(row))}
                    sx={{
                      position: "relative",
                      overflow: "hidden",
                      p: "3px",
                      cursor: "pointer",
                    }}
                  >
                    <Avatar
                      alt={row.name}
                      src={row.image}
                      sx={{
                        width: "100%",
                        height: "164px",
                        borderRadius: "16px",
                        boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Tahrir",
                        fontWeight: 700,
                        fontSize: "24px",
                        lineHeight: "32px",
                        position: "absolute",
                        bottom: "12px",
                        left: "18px",
                        zIndex: 1,
                        color: "white.main",
                      }}
                    >
                      {row.name}
                    </Typography>
                    <Box
                      sx={{
                        position: "absolute",
                        backgroundImage:
                          "linear-gradient(to bottom, rgba(255,0,0,0), #21212194 70%,#212121)",
                        // backgroundColor: "black.main",
                        top: 2,
                        bottom: 2,
                        left: 2,
                        right: 2,
                        borderRadius: "16px",
                        opacity: 0.65,
                      }}
                    ></Box>
                  </Box>
                </Grid2>
              );
            })}
        </Grid2>
        {!isLoading && category && (
          <Box
            ref={ref}
            sx={{ display: "flex", justifyContent: "center" }}
          ></Box>
        )}
      </Box>
    </Box>
  );
};

export default Category;
